<template>
  <div class="flex flex-col">
    <h2 class="heading-1 mb-16">
      {{ i18n(translations.titleStep) }}
    </h2>
    <CardGuidance
      :clickable="true"
      data-qa="open-tradein-au-modal-button"
      data-test="open-tradein-au-modal-button"
      :icon="IconSwap"
      :label="i18n(translations.swapCardGuidance)"
      :modal-name="MODAL_NAMES.TRADEIN_AU"
    />
    <TradeInOffer
      v-if="acceptedOffer"
      class="mb-8"
      :name="acceptedOffer.productShortTitle"
      :price="acceptedOffer.price"
    />
    <RevIllustration
      v-else
      alt="Trade-in opportunities"
      class="rounded-lg hidden w-full min-w-[250px] max-w-[250px] md:block self-center"
      :height="250"
      :src="'/img/tradein-au/step-trade-in-jp.png'"
      :width="250"
    />
    <TradeInModal market="jp" :modal-name="MODAL_NAMES.TRADEIN_AU" />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { IconSwap } from '@ds/icons/IconSwap'

import CardGuidance from '~/scopes/product-core/components/presentationals/CustomizationFunnel/components/CardGuidance/CardGuidance.vue'
import TradeInModal from '~/scopes/tradein-au/components/TradeInModal/TradeInModal.vue'
import TradeInOffer from '~/scopes/tradein-au/components/TradeInOffer/TradeInOffer.vue'
import { useTradeInAuOffer } from '~/scopes/tradein-au/composables/useTradeInAuOffer'
import { MODAL_NAMES } from '~/scopes/tradein-au/constants'

import translations from './Step.translations'

const i18n = useI18n()

const { acceptedOffer } = useTradeInAuOffer('jp')
</script>
